function Datenschutz() {
    return (
        <div style={{ textAlign: "center" }}>
            <h2>Vorschlagsformular</h2>
            <br/>

            Wenn Sie Döner Sonntag über das Formular auf dieser Website einen Vorschlag übermitteln, werden die von Ihnen eingegebenen Daten (z. B. Name, E-Mail-Adresse, Inhalt der Nachricht) ausschließlich zum Zweck der Bearbeitung Ihres Anliegens verarbeitet.
            Die Angaben werden per E-Mail an uns weitergeleitet und nicht dauerhaft in einer Datenbank gespeichert. Eine Weitergabe an Dritte findet nicht statt.

            Die übermittelten Daten verbleiben so lange im Döner Sonntag E-Mail-Postfach, wie dies zur Bearbeitung des Vorschlags erforderlich ist. Anschließend werden sie gelöscht, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.

            Die Verarbeitung der Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), indem Sie uns Ihre Angaben freiwillig über das Formular zusenden. Sie können diese Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen, indem Sie Döner Sonntag eine formlose Nachricht senden an: tobias.franz@posteo.de.
        </div>


    )
}

export default Datenschutz;